import { makeStyles } from '@material-ui/core';

import { neutral } from '../../../shared/styles/colors';

export default makeStyles({
  root: {
    backgroundColor: neutral[10],
    paddingTop: '0.75rem',
  },
  chipsRoot: {
    display: 'flex',
    gridGap: '0.5rem',
  },
  toolBarRoot: {
    padding: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${neutral['20']}`,
    fontFamily: 'Poppins',
    fontSize: '1rem',
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 'normal',
    letterSpacing: 'normal',
    lineHeight: 'normal',
    color: neutral['90'],
    backgroundColor: neutral.white,
    marginBottom: '0.5rem',
  },
  showFiltersButton: {
    backgroundColor: neutral.white,
    borderRadius: '1.25rem',
    fontSize: '0.75rem',
    padding: '0.375rem 0.6875rem',
  },
});
